import { render, staticRenderFns } from "./condimentsList.vue?vue&type=template&id=0dcbdefc&scoped=true&"
import script from "./condimentsList.vue?vue&type=script&lang=js&"
export * from "./condimentsList.vue?vue&type=script&lang=js&"
import style0 from "./condimentsList.vue?vue&type=style&index=0&id=0dcbdefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcbdefc",
  null
  
)

export default component.exports